import React from 'react';

import { Table, Input, Button } from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';

import { APP_DOMAIN_COMISSAO } from '../config/urls';

class TableTodos extends React.Component {
  
  state = {};
  
  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input 
          ref={node => {this.searchInput = node}} 
          placeholder={"Buscar por"} 
          value={selectedKeys[0]} 
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])} 
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)} 
          style={{width: 188, marginBottom: 8, display: "block"}}
        />
        <Button type="primary" onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)} icon={<SearchOutlined />} size="small" style={{width: 90, marginRight: 8}}>Pesquisar</Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{width: 90}}>Cancelar</Button>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{color: filtered ? "#1890ff" : undefined}}/>,
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text => this.state.searchedColumn === dataIndex ? 
      (
        <Highlighter highlightStyle={{backgroundColor: "#ffc069", padding: 0}} searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render () {
    const columns = [
      {
        title: 'Contrato',
        key: 'numero',
        ...this.getColumnSearchProps('numero'),
        render: record => <span className="pointer" onClick={() => {this.props.onSelectChange(record)}}>{record.numero}</span>
      },
      {
        title: 'Cidade',
        key: 'cidade',
        ...this.getColumnSearchProps('cidade'),
        render: record => <span className="pointer" onClick={() => {this.props.onSelectChange(record)}}>{record.cidade}</span>
      },
      {
        title: 'Estado',
        key: 'estado',
        ...this.getColumnSearchProps('estado'),
        render: record => <span className="pointer" onClick={() => {this.props.onSelectChange(record)}}>{record.estado}</span>
      },
      {
        title: 'Instituição',
        key: 'instituicao',
        ...this.getColumnSearchProps('instituicao'),
        render: record => <span className="pointer" onClick={() => {this.props.onSelectChange(record)}}>{record.instituicao}</span>
      },
      {
        title: 'Sigla',
        key: 'sigla',
        ...this.getColumnSearchProps('sigla'),
        render: record => <span className="pointer" onClick={() => {this.props.onSelectChange(record)}}>{record.sigla}</span>
      },
      {
        title: 'Curso',
        key: 'curso',
        ...this.getColumnSearchProps('curso'),
        render: record => <span className="pointer" onClick={() => {this.props.onSelectChange(record)}}>{record.curso}</span>
      },
      {
        title: 'Representante',
        key: 'representante',
        ...this.getColumnSearchProps('representante'),
        render: record => <span className="pointer" onClick={() => {this.props.onSelectChange(record)}}>{record.representante}</span>
      },
      {
        title: 'Data de formatura',
        key: 'dataFormatura',
        render: record => <span className="pointer" onClick={() => {this.props.onSelectChange(record)}}>{record.dataFormatura ? new Date(new Date(record.dataFormatura).setUTCHours(3)).toLocaleDateString("pt-br", {timezome: "UTC"}) : ""}</span>
      },
      {
        title: 'Data de entrega',
        key: 'dataEntrega',
        render: record => <span className="pointer" onClick={() => {this.props.onSelectChange(record)}}>{record.dataEntrega ? new Date(new Date(record.dataEntrega).setUTCHours(3)).toLocaleDateString("pt-br", {timezome: "UTC"}) : ""}</span>
      },
      {
        title: 'Ações',
        key: 'action',
        render: (record) => (
          <span style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
            <i style={{color: record.cadastrouFormandos === 1 ? "#1890ff" : "rgba(0, 0, 0, 0.65)", marginRight: 5, marginLeft: 5, cursor: "pointer"}} title="Ver informações dos formandos" className="fa fa-graduation-cap" onClick={() => {this.props.abrirDetalhesFormando(record)}}/>
            <i style={{color: record.distribuiuItens === 1 ? "#1890ff" : "rgba(0, 0, 0, 0.65)", marginRight: 5, marginLeft: 5, cursor: "pointer"}} title="Ver planilha de quantidades" className="fa fa-table" onClick={() => {this.props.abrirDetalhesDistribuicao(record)}}/>
            { record.sistemaPagto === 1 && (this.props.usuarioLogado.tipo === "orc" || this.props.usuarioLogado.tipo === "administrador") ? <i style={{marginRight: 5, marginLeft: 5, cursor: "pointer"}} title="Ver planilha de quantidades do orçamentista" className="fa fa-file" onClick={() => {this.props.abrirDetalhesDistribuicaoOrcamentista(record)}}/> : null }
            { ["orc", "administrador"].includes(this.props.usuarioLogado.tipo) ? <i style={{marginRight: 5, marginLeft: 5, cursor: "pointer"}} title="Ver as informações pertinentes ao módulo de pagamento" className="fa fa-credit-card" onClick={() => {this.props.abrirDetalhesModuloPagamento(record)}}/> : null }
            <i style={{color: "rgba(0, 0, 0, 0.65)", marginRight: 5, marginLeft: 5, cursor: "pointer"}} title="Ver planilha de usuários da personalizada" className="fa fa-id-badge" onClick={() => {this.props.abrirLoginsPersonalizada(record)}}/>
            { ["orc", "administrador"].includes(this.props.usuarioLogado.tipo) ? <a target="_blank" href={`${APP_DOMAIN_COMISSAO}/login?email=${record.usuario.login}&senha=${record.usuario.senha}&alphaAdmin=true`} title="Acessar a Área dos Formandos"><i style={{marginRight: 5, marginLeft: 5, cursor: "pointer"}} className="fa fa-eye"/></a> : null }
          </span>
        ),
      }
    ];
    return (   
      <div className="table-responsive">
        <Table columns={columns} dataSource={this.props.contratos} rowKey={record => record.id} bordered />
      </div>
    );
  }
}

export default TableTodos;


// WEBPACK FOOTER //
// ./src/components/TableTodos.js